module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_TOC_Heading",
    attrs: {
      "id": "tableofcontents"
    }
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0002#auto_bookmark_toc_1"
    }
  }, [_vm._v("Sneak Peek")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0003#auto_bookmark_toc_1"
    }
  }, [_vm._v("Hiding In Plain Sight")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0004#auto_bookmark_toc_1"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0005#auto_bookmark_toc_1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('a', {
    attrs: {
      "href": "#/section0006#auto_bookmark_toc_1"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0007#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0008#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0009#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0010#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0011#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0012#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0013#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0014#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0015#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0016#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0017#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0018#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0019#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0020#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0021#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0022#auto_bookmark_toc_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0023#auto_bookmark_toc_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Bru Baker")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0024#auto_bookmark_toc_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now Available")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Visit Dreamspinner Press")])]), _vm._v(" "), _c('p', {
    staticClass: "P_TOC_Entry_1"
  }, [_c('span', {
    attrs: {
      "href": "#/section0026#auto_bookmark_toc_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34a0e764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0001.vue
// module id = 54
// module chunks = 0